/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_AddInputs */

const en_us2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise added to the plan`)
};

const pt_br2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício adicionado ao plano`)
};

const es_419_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio agregado al plan`)
};

const pt_pt2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício adicionado ao plano`)
};

const fr_fr2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice ajouté au programme`)
};

const de_de2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung zum Plan hinzugefügt`)
};

const it_it2_offline_kind_plan_add = /** @type {(inputs: Offline_Kind_Plan_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio aggiunto alla scheda`)
};

/**
* | output |
* | --- |
* | "Exercise added to the plan" |
*
* @param {Offline_Kind_Plan_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_add = /** @type {((inputs?: Offline_Kind_Plan_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_add(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_add(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_add(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_add(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_add(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_add(inputs)
	return en_us2_offline_kind_plan_add(inputs)
});
export { offline_kind_plan_add as "offline.kind_plan_add" }